export default {"src":"/_next/static/media/england.04b04ac6.svg","height":48,"width":48,"blurWidth":0,"blurHeight":0};